module.exports = __webpack_public_path__ + "img/Ajustes_activo.01571c67.svg";